
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeZhongyitizhi extends Vue {
  @Prop()
  private message: any;
}
